module.exports = __webpack_public_path__ + "static/img/users_image.4cdbface.png";